import React, { Component } from 'react'
import { withStyles, Card, CardContent, Typography, CardHeader, Avatar, Chip, Grid } from '@material-ui/core';
import People from '@material-ui/icons/Person'
import { lightBlue } from '@material-ui/core/colors';
import PieChart from 'react-minimal-pie-chart';

const styles = theme => ({
    NumberCard: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '10px'

    },
    NumberCardLeft: {
        padding: '10px',
        border: `solid thin ${lightBlue[200]}`,
        flexBasis: '60%'
    },
    NumberCardRight: {
        padding: '10px',
        backgroundColor: lightBlue[300],
        border: `solid thin ${lightBlue[200]}`,
        flexBasis: '20%',
        textAlign: 'center'
    },
    cardListContainer: {
        display: 'flex',
        flexDirection: 'column'
    }
})

class AttendanceReportSingle extends Component {
    render() {
        let { classes } = this.props;
        return (
            <div>
                <Card>

                    <CardHeader
                        avatar={
                            <Avatar style={{backgroundColor: lightBlue[300]}}>
                                <People />
                            </Avatar>
                        }
                        title={
                            <div>
                                <Typography
                                    variant="h6"
                                >
                                    {this.props.name}
                    </Typography>
                            </div>
                        }

                        subheader={
                            <div>
                                {this.props.roll_no}<br />
                                <Chip label={this.props.course} />
                                <Chip label={this.props.stream} />
                                <Chip label={this.props.dept_code} />
                                <Chip label={this.props.semester} />
                                
                            </div>

                        }
                    />
                    <CardContent>
                        <Grid container spacing={24}>
                            <Grid item xs={12} lg={4} className={classes.cardListContainer}>

                                <NumberCard
                                    {...this.props}
                                    label="Total Classes"
                                    value={this.props.total_class}
                                />

                                <NumberCard
                                    {...this.props}
                                    label="Attended Classes"
                                    value={this.props.attended_class}
                                />

                                <NumberCard
                                    {...this.props}
                                    label="Absent Classes"
                                    value={this.props.not_attended_class}
                                />

                            </Grid>

                            <Grid item xs={12} lg={4}>

                                <ul style={{ listStyleType: 'none' }}>
                                    <li><span style={{ backgroundColor: '#18ffff' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>  Present ({this.props.percentage}%)</li>
                                    <li><span style={{ backgroundColor: '#C13C37' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>  Absent ({100 - this.props.percentage}%)</li>
                                </ul>

                                <br/>

                                <PieChart
                                animate
                                    data={[
                                        { title: 'One', value: this.props.percentage, color: '#18ffff' },
                                        { title: 'Two', value: 100-this.props.percentage, color: '#C13C37' }
                                    ]}
                                />
                                
                                

                            </Grid>


                            


                            
                        </Grid>



                    </CardContent>
                </Card>
            </div>
        )
    }
}

export default withStyles(styles)(AttendanceReportSingle);


const NumberCard = (props) => {
    let { classes } = props;
    return (
        <div className={classes.NumberCard}>
            <div className={classes.NumberCardLeft}>
                <Typography
                    variant="h6"
                >
                    {props.label}
                </Typography>
            </div>

            <div className={classes.NumberCardRight}>
                <Typography
                    variant="h6"
                    style={{ color: 'white' }}
                >
                    {props.value}
                </Typography>
            </div>
        </div>
    )
}